import React from 'react';
import styled from 'styled-components';
import {
  colors,
  fonts,
  radii,
  shadows,
  breakpoints,
  headingStyle,
  containerStyle,
  sectionPaddingStyle,
  icones,
} from './designSystem';

// ---------------------------------------------------------------------------
// Styled Components
// ---------------------------------------------------------------------------

const Section = styled.section`
  margin: 0;
  ${sectionPaddingStyle}
  background-color: ${colors.bleuPastel};
`;

const Container = styled.div`
  ${containerStyle}
`;

const Heading = styled.h2`
  ${headingStyle}
  font-size: 1.5rem;
  margin-bottom: 32px;

  @media (min-width: ${breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Emphasis = styled.span`
  color: ${colors.bleu};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
`;

const CityLink = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  background-color: ${colors.white};
  border-radius: 16px;
  box-shadow: ${shadows.card};
  text-decoration: none;
  color: ${colors.textDark};
  font-family: ${fonts.body};
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    color: ${colors.bleu};
    box-shadow: 0 6px 16px rgba(49, 73, 89, 0.12);
  }
`;

const LocIcon = styled.img`
  width: 16px;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
`;

const CityCount = styled.span`
  margin-left: auto;
  font-size: 0.75rem;
  color: ${colors.textSecondary};
  font-weight: 400;
  white-space: nowrap;
`;

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export default function VillesProches({ name, villesProches }) {
  if (!villesProches || villesProches.length === 0) return null;

  return (
    <Section>
      <Container>
        <Heading>
          Ateliers v&eacute;lo <Emphasis>autour</Emphasis> de {name || ''}
        </Heading>
        <Grid>
          {villesProches.map((ville, i) => {
            const slug = ville.slug || '';
            const deptSlug = ville.dept_slug || '';
            const href = deptSlug
              ? `/annuaire-velo/${deptSlug}/${slug}`
              : `/annuaire-velo/${slug}`;
            const count = ville.nb_shops;
            return (
              <CityLink key={slug || i} href={href}>
                <LocIcon src={icones.localisation} alt="" />
                {ville.name || ''}
                {count != null && count > 0 && (
                  <CityCount>
                    {count} atelier{count !== 1 ? 's' : ''}
                  </CityCount>
                )}
              </CityLink>
            );
          })}
        </Grid>
      </Container>
    </Section>
  );
}
